import comm_data from '../comm_data';
import './dataHandler_dateFormat';
import api from './api';
import ApiGo_AuditTrail from './ApiGo_AuditTrail';
// import i18n from './../i18n';

/**
 * url, method, headers, data, returnData
 * `${comm_data.API_HOST}/${apiParas.para}/${apiParas.resident_id}/${apiParas.date}`
 *
 * 敵動程式
 * import ApiGo 完
 * ApiGo.getUser('userId')
 */
export default class ApiGo {
  // ※static 靜態屬性不需要實例化也可以調用，可以減少內存的配置
  // NOTE: 全域共同函數
  static toSearchParams({ _params }) { }

  /**
   * // ✎NOTE: ---------〖GET - 測試try...catch的腳本〗---------
   */
  static getTest() {
    const apiParas = {
      type: 'beds',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
    });
  }

  // NOTE: Setting query string using Fetch GET request
  /**
   * [PJChender/[JS] 使用 JavaScript 解析網址與處理網址中的參數（URL Parameters）](https://pjchender.blogspot.com/2018/08/js-javascript-url-parameters.html)
   * [Stackoverflow/How do I POST data and parameters like in Axios, using Fetch API](https://stackoverflow.com/questions/51935090/how-do-i-post-data-and-parameters-like-in-axios-using-fetch-api)
   * [Stackoverflow/Setting query string using Fetch GET request](https://stackoverflow.com/questions/35038857/setting-query-string-using-fetch-get-request)
   */
  // static useParams(_url, _param) {
  static testParams(_url, _params) {
    // 192.168.0.50/breath/19/2021-08-06
    const apiParas = {
      url: new URL(_url),
      // params: { lat: 35.696233, long: 139.570431 }
      params: _params,
    };
    Object.keys(apiParas.params).forEach((key) => apiParas.url.searchParams.append(key, apiParas.params[key]));

    return api({});
  }
  static getEpmedDevice() {
    // 'http://192.168.0.30:8080/get_epmed_device' \

    const apiParas = {
      type: 'get_epmed_device',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
    });
  }

  static postCreateEpmedDevice(product_id, device_id, type) {
    // 'http://192.168.0.30:8080/create_epmed_device' \

    const apiParas = {
      type: 'create_epmed_device',
      data: {
        product_id: product_id,
        device_id: device_id,
        type: type,
      },
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST', //請求方法
      data: apiParas.data,
      type: apiParas.type,
    });
  }
  static getStartBloodPressureService() {
    //'http://192.168.0.30:8080/epmed_test_start' \

    const apiParas = {
      type: 'epmed_test_start',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
    });
  }
  static getStopBloodPressureService() {
    //'http://192.168.0.30:8080/epmed_test_stop' \

    const apiParas = {
      type: 'epmed_test_stop',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
    });
  }
  static getBedsteads() {
    // http://192.168.0.30:8080/bedsteads

    const apiParas = {
      type: 'bedsteads',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
    });
  }
  /**
   * // ✎NOTE: ---------〖post - 建立床體資訊，不帶任何參數〗---------
   */
  static postCreateBedsteads() {
    // http://192.168.0.30:8080/create_bedsteads

    const apiParas = {
      type: 'create_bedsteads',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST',
      type: apiParas.type,
    });
  }
  /**
   * // ✎NOTE: ---------〖delete - 刪除床體〗---------
   *      * @param {Integer} id 床的id
   */
  static deleteBedsteads(id) {
    // 'http://192.168.0.30:8080/delete_bedstead?id=6' \

    const apiParas = {
      type: 'delete_bedstead',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?id=${id}`,
      method: 'DELETE', //請求方法
      type: apiParas.type,
    });
  }
  /**
   * // ✎NOTE: ---------〖delete - 解除床體配對〗---------
   */
  static removeBedsteads(bedstead_id, resident_id) {
    // 'http://192.168.0.30:8080/remove_bedstead' \

    const apiParas = {
      type: 'remove_bedstead',
      data: {
        bedstead_id: bedstead_id,
        resident_id: resident_id,
      },
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'DELETE', //請求方法
      data: apiParas.data,
      type: apiParas.type,
    });
  }
  static updateBedsteads(bedstead_id, order) {
    // http://192.168.0.30:8080/update_bedstead

    const apiParas = {
      type: 'update_bedstead',
      data: {
        bedstead_id: bedstead_id,
        order: order,
        height: 0,
        back_angel: 0,
        foot_angel: 0,
      },
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'PUT', //請求方法
      data: apiParas.data,
      type: apiParas.type,
    });
  }
  /**
   * // ✎NOTE: ---------〖post - 配對床體〗---------
   *      * @param {Integer} bedstead_id 床的id
   *      * @param {Integer} resident_id 床的id
   */
  static matchBedsteads(bedstead_id, resident_id) {
    //   'http://192.168.0.30:8080/matching_bedstead' \

    const apiParas = {
      type: 'matching_bedstead',
      data: {
        bedstead_id: bedstead_id,
        resident_id: resident_id,
      },
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST', //請求方法
      data: apiParas.data,
      type: apiParas.type,
    });
  }

  // NOTE: Sleep Quality
  /**
   * // ✎NOTE: ---------〖GET - 透過bed查詢睡眠品質 (SE為睡眠品質)〗---------
   *
   * @param {String} _bed_id 床的id(resident_id: 19 等於 bed_id: 20)
   * @param {String} _from_date 查詢開始日期(YYYY-MM-DD)
   * @param {String} _to_date 查詢結束日期(YYYY-MM-DD)
   */
  static getSleepQuality(_bed_id, _from_date, _to_date) {
    // http://192.168.0.50/get_latest_sleep_quality_by_bed/20/2021-08-06/2021-10-19
    const apiParas = {
      type: 'get_latest_sleep_quality_by_bed',
      bed_id: _bed_id || '20', // 有資料 id(床-無線版)
      from_date: _from_date || '2021-08-06',
      to_date: _to_date || '2021-10-19',
      // to_date: _to_date || (new Date).Format("yyyy-MM-dd"), // 當天日期
    };

    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas.bed_id}/${apiParas.from_date}/${apiParas.to_date}`,
    });
  }

  // NOTE: SleepQuality_ByResident
  /**
   * // ✎NOTE: ---------〖GET - 透過bed查詢睡眠品質 (SE為睡眠品質)〗---------
   *
   * @param {String} _resident_id 受護者id(resident_id: 19 等於 bed_id: 20)
   * @param {String} _from_date 查詢開始日期(YYYY-MM-DD)
   * @param {String} _to_date 查詢結束日期(YYYY-MM-DD)
   */
  static getSleepQuality_ByResident(_resident_id, _from_date, _to_date) {
    // http://192.168.0.50/get_latest_sleep_quality_by_resident/20/2021-08-06/2021-10-19
    const apiParas = {
      type: 'get_latest_sleep_quality_by_resident',
      resident_id: _resident_id || '20', // 有資料 id(床-無線版)
      from_date: _from_date || '2021-08-06',
      to_date: _to_date || '2021-10-19',
      // to_date: _to_date || (new Date).Format("yyyy-MM-dd"), // 當天日期
    };

    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas.resident_id}/${apiParas.from_date}/${apiParas.to_date}`,
    });
  }
  static getFsensor_ByResident(_resident_id, _from_date, _to_date) {
    // http://192.168.0.50/get_latest_FSensor_by_resident/20/2021-08-06/2021-08-06
    const apiParas = {
      type: 'get_latest_FSensor_by_resident',
      resident_id: _resident_id || '20', // 有資料 id(床-無線版)
      from_date: _from_date || '2021-08-06',
      to_date: _to_date || '2021-10-19',
      // to_date: _to_date || (new Date).Format("yyyy-MM-dd"), // 當天日期
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas.resident_id}/${apiParas.from_date}/${apiParas.to_date}`,
    });
  }
  // NOTE: Breath
  /**
   * // ✎NOTE: ---------〖GET - 該床 受護者的呼吸〗---------
   *
   * @param {String} _resident_id 受護者id(resident_id: 19 等於 bed_id: 20)
   * @param {String} _date 查詢結束日期(YYYY-MM-DD)
   */
  static getBreath(_resident_id, _from, _to) {
    // 192.168.0.50/breath/19/2021-08-06
    const apiParas = {
      type: 'breath',
      resident_id: _resident_id || '', // 有資料 id(床-無線版): 19
      // date: _date || '2021-08-06', // 有資料: '2021-08-06'
      from: _from || new Date().Format('yyyy-MM-dd hh:mm:ss'), // 當天日期
      to: _to || new Date().Format('yyyy-MM-dd hh:mm:ss'), // 當天日期
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas.resident_id}/${apiParas.from}/${apiParas.to}`,
    });
  }

  static postHR_RR_abnormal_info(_resident_id, heart_high, heart_low, breath_high, breath_low, _from, _to) {
    // http://192.168.0.50:8080/HR_RR_abnormal_info/
    const apiParas = {
      type: 'HR_RR_abnormal_info',
    };
    const apiData = {
      resident_id: _resident_id || '', // 有資料 id(床-無線版): 19
      heart_high: heart_high,
      heart_low: heart_low,
      breath_high: breath_high,
      breath_low: breath_low,
      from_time: _from || new Date().Format('yyyy-MM-dd hh:mm:ss'), // 當天日期
      to_time: _to || new Date().Format('yyyy-MM-dd hh:mm:ss'), // 當天日期
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      data: apiData,
      method: 'POST',
      type: apiParas.type,
      audit_trial_excluded: true,
    });
  }

  // NOTE: Breath
  /**
   * // ✎NOTE: ---------〖GET - 該床 受護者的呼吸〗---------
   *
   * @param {String} _resident_id 受護者id(resident_id: 19 等於 bed_id: 20)
   * @param {String} _date 查詢結束日期(YYYY-MM-DD)
   */
  static getVital_Curve(_resident_id, _from, _to) {
    // 192.168.0.50/breath/19/2021-08-06
    const apiParas = {
      type: 'vital_curve',
      resident_id: _resident_id || '', // 有資料 id(床-無線版): 19
      // date: _date || '2021-08-06', // 有資料: '2021-08-06'
      from: _from || new Date().Format('yyyy-MM-dd hh:mm:ss'), // 當天日期
      to: _to || new Date().Format('yyyy-MM-dd hh:mm:ss'), // 當天日期
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas.resident_id}/${apiParas.from}/${apiParas.to}`,
    });
  }

  // NOTE: Alert
  // ✎NOTE: ---------〖GET - 取得所有用戶〗---------
  static getMobility_inbed(_id, _date) {
    // http://192.168.0.50/alert/20/2021-08-19/ALL
    const apiParas = {
      type: 'get_Mobility_inbed',
      resident_id: _id || '19',
      date: _date,
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas.resident_id}/${apiParas.date}`,
    });
  }

  // NOTE: Alert
  // ✎NOTE: ---------〖GET - 取得所有用戶〗---------
  static getAlert(_id, _date, _timestamp) {
    /**
     * ALL: 00:00:00~23:59:59
     * GS: 00:00:00~07:59:59
     * MS: 08:00:00~15:59:59
     * NS: 16:00:00~23:59:59
     */
    // http://192.168.0.50/alert/20/2021-08-19/ALL
    const apiParas = {
      type: 'alert',
      resident_id: _id || '19',
      date: _date || new Date().Format('yyyy-MM-dd'), // 有資料
      // date: _date || (new Date).Format("yyyy-MM-dd"), // 有資料
      // date: (new Date).Format("yyyy-MM-dd"), // 當天日期
      timestamp: _timestamp || 'ALL',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas.resident_id}/${apiParas.date}/${apiParas.timestamp}`,
    });
  }
  // NOTE: Alert
  // ✎NOTE: ---------〖GET - 取得所有用戶〗---------
  static getAlert_for_vital(_id, _fromtime, _totime) {
    /**
     * ALL: 00:00:00~23:59:59
     * GS: 00:00:00~07:59:59
     * MS: 08:00:00~15:59:59
     * NS: 16:00:00~23:59:59
     */
    // http://192.168.0.50/alert_for_Vital/174/2023-01-1%2003%3A26%3A48/2023-01-31%2003%3A26%3A48
    const apiParas = {
      type: 'alert_for_Vital',
      resident_id: _id || '19',
      _fromtime: _fromtime || new Date().Format('yyyy-MM-dd HR:MIN:SEC'), // 有資料
      _totime: _totime || new Date().Format('yyyy-MM-dd HR:MIN:SEC'), // 有資料
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas.resident_id}/${apiParas._fromtime}/${apiParas._totime}`,
    });
  }
  // NOTE: Alert
  // ✎NOTE: ---------〖GET - 取得所有用戶〗---------
  static getAll_resident_bed_state_alerts(_date, _timestamp) {
    // http://192.168.0.50/all_resident_bed_state_alerts/2021-08-19/ALL
    const apiParas = {
      type: 'all_resident_bed_state_alerts',
      date: _date || new Date().Format('yyyy-MM-dd'), // 有資料
      timestamp: _timestamp || 'ALL',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas.date}/${apiParas.timestamp}`,
    });
  }
  // NOTE: Alert
  // ✎NOTE: ---------〖GET - 取得所有用戶〗---------
  static getAll_resident_vital_abnormal(_date, _timestamp) {
    // http://192.168.0.50:8080/all_resident_vital_abnormal/z/z
    const apiParas = {
      type: 'all_resident_vital_abnormal',
      date: _date || new Date().Format('yyyy-MM-dd'), // 有資料
      timestamp: _timestamp || 'ALL',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas.date}/${apiParas.timestamp}`,
    });
  }
  // NOTE: Alert
  // ✎NOTE: ---------〖GET - 取得所有用戶〗---------
  static putUpdate_alerts_resolved(resident_id, resolved_user_id) {
    // http://192.168.0.50:8080/update_alerts_resolved
    const apiParas = {
      type: 'update_alerts_resolved',
    };

    const data = {
      resident_id: resident_id,
      resolved_user_id: resolved_user_id,

    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'PUT',
      data: data,
      type: apiParas.type,
    });
  }

  // NOTE: Alert - 單筆
  // ✎NOTE: ---------〖GET - 取得單個 mac 的 alert〗---------
  static get_mac_latest_bed_state(_mac) {
    // http://192.168.0.50:8080/get_mac_latest_bed_state?mac=246F28552B18
    const apiParas = {
      type: 'get_mac_latest_bed_state',
      mac: _mac,
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?mac=${apiParas.mac}`,
    });
  }

  // NOTE: Beds
  /**
   * // ✎NOTE: ---------〖GET - 查詢目前所有bed資訊〗---------
   */
  static getBed() {
    const apiParas = {
      type: 'bed',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
    });
  }

  static getSystemDesktopOrServer() {
    // 'http://192.168.0.30:8080/get_system_info'
    const apiParas = {
      type: 'get_system_info',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
    });
  }
  // NOTE: macs_rssi 給 admin 用
  /**
   * // ✎NOTE: ---------〖GET - 查詢目前所有bed 在 admin 需要的資訊〗---------
   */
  static getMacs_rssi_all() {
    const apiParas = {
      type: 'macs_rssi_all',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
    });
  }
  static postCal_RSSI_calculation() {
    const apiParas = {
      type: 'cal_RSSI_calculation',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST',
      type: apiParas.type,
    });
  }

  static getAlert_speak_count() {
    // 'http://192.168.0.72:8080/alert_speak_count' \
    const apiParas = {
      type: 'alert_speak_count',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
    });
  }
  static putAlert_speak_count(count, speed) {
    // http://192.168.0.72:8080/alert_speak_count?alert_speak_count=2
    const apiParas = {
      type: 'alert_speak_count',
      speed: 'alert_speak_speed',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?${apiParas.type}=${count}&${apiParas.speed}=${speed}`,
      method: 'PUT',
    });
  }
  // NOTE: BedStatus
  /**
   * // ✎NOTE: ---------〖GET - 查目前讓bed的最新資訊_含自動翻身次數〗---------
   *
   * @param {Integer} _bed_id 數值 1: 輸入該床的bed_id
   */
  static getBedStatus(_bed_id) {
    const apiParas = {
      type: 'bed_status',
      bed_id: _bed_id || null,
    };

    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas.bed_id}`,
    });
  }

  // NOTE: Bed status 2 ui
  /**
   * // ✎NOTE: ---------〖GET - 查詢bed目前最新狀態ui初始值〗---------
   *
   * @param {Integer} _resident_id 數值 1: 輸入該床的 resident_id
   */
  static getBedStatus2ui(_resident_id) {
    const apiParas = {
      type: 'bed_status2ui',
      _resident_id: _resident_id || null,
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas._resident_id}`,
    });
  }
  // NOTE: Bed status 2 ui
  /**
   * // ✎NOTE: ---------〖GET - 查詢bed目前最新狀態ui初始值〗---------
   *
   * @param {Integer} _resident_id 數值 1: 輸入該床的 resident_id
   */
  static getlatest_bed_status(_resident_id) {
    // http://192.168.0.99:8080/bed_status2ui/1
    const apiParas = {
      type: 'latest_bed_status',
      _resident_id: _resident_id || null,
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas._resident_id}`,
    });
  }

  // NOTE: Bed status 2 ui
  /**
   * // ✎NOTE: ---------〖GET - 查詢bed目前最新狀態ui初始值〗---------
   *
   * @param {Integer} _resident_id 數值 1: 輸入該床的 resident_id
   */
  static getBedStatusHistory(_resident_id, _time) {
    //  http://192.168.0.50:8080/bed_status_history/56/2022-04-28
    const apiParas = {
      type: 'bed_status_history',
      resident_id: _resident_id || null,
      time: _time,
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas.resident_id}/${apiParas.time}`,
    });
  }

  static getBed_auto_parameter_by_id(_auto_parameter_id) {
    // http://192.168.0.50:8080/bed_auto_parameter_by_id/1098
    const apiParas = {
      type: 'bed_auto_parameter_by_id',
      auto_parameter_id: _auto_parameter_id || null,
    };

    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas.auto_parameter_id}`,
    });
  }

  // NOTE: Bed auto parameters
  /**
   * // ✎NOTE: ---------〖GET - 查目前讓bed的最新資訊_含自動翻身次數〗---------
   *
   * @param {Integer} _bed_id 數值 1: 輸入該床的bed_id
   */
  static getBedAuto_parameter(_bed_id) {
    //  http://192.168.0.50:8080/bed_auto_parameter_history/56/2022-04-29
    const apiParas = {
      type: 'bed_auto_parameter',
      bed_id: _bed_id || null,
    };

    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas.bed_id}`,
    });
  }
  // NOTE: Bed auto parameters
  /**
   * // ✎NOTE: ---------〖GET - 查目前讓bed的最新資訊_含自動翻身次數〗---------
   *
   * @param {Integer} _bed_id 數值 1: 輸入該床的bed_id
   */
  static getBedAuto_parameter_history(_resident_id, _time) {
    //  http://192.168.0.50:8080/bed_auto_parameter_history/56/2022-04-29
    const apiParas = {
      type: 'bed_auto_parameter_history',
      resident_id: _resident_id || null,
      time: _time,
    };

    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas.resident_id}/${apiParas.time}`,
    });
  }

  // NOTE: Residents
  /**
   * // ✎NOTE: ---------〖PUT - 人配床〗---------
   *
   * @param {String} mac 數值 1: MAC ID
   * @param {String} _resident_id 數值 2: 受護者 ID
   * @param {String} {element} 數值: 捉取外部元素
   *
   */
  static putBedTest(mac, _resident_id, { element } = {}) {
    /**
     * 測試範本
     * http://192.168.0.50/residents/{id}
     * 陣列 59
     * _resident_id: 78 (Daly)
     *
     * http://192.168.0.50/bedcheck
     * mac: wasdwasdwaDF
     */
    const apiParas = {
      type: 'person_with_bed',
    };
    const data = {
      mac: mac || 'wasdwasdwaDF',
      resident_id: _resident_id || null,
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'PUT', // 請求方法
      data: data,
      element: element,
      type: apiParas.type,
    });
  }

  // NOTE: ​Residents
  // ✎NOTE: ---------〖GET - 取得 residents id 個別資料 || 全部資料 〗---------
  static getResidentsId(_id) {
    // http://192.168.0.50/residents/{id}
    const apiParas = {
      type: 'residents',
      resident_id: _id || '',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas.resident_id}`,
    });
  }
  // NOTE: ​Residents
  // ✎NOTE: ---------〖GET - 取得 residents id 個別資料 || 全部資料 〗---------
  static getResidents() {
    // http://192.168.0.50/residents
    const apiParas = { type: 'residents' };
    return api({ url: `${comm_data.API_HOST}/${apiParas.type}` });
  }
  // NOTE: ​Residents
  // ✎NOTE: ---------〖GET - 取得 residents id 個別資料 || 全部資料 含房號列表 〗---------
  static getALLResidentsList() {
    // http://192.168.0.50/residents
    const apiParas = { type: 'residents_room_list' };
    return api({ url: `${comm_data.API_HOST}/${apiParas.type}` });
  }
  // ✎NOTE: ---------〖POST - Residents〗---------
  static postResidents({ _first_name, _last_name, _mac_left, _mac_right, _mac_down, _lyingside_check, _weight, _auto_frequency_day, _auto_frequency_night, _user_id, _leave_hospital, _case_num }) {
    // http://192.168.0.50/postResidents/20/2021-08-19/ALL
    const apiParas = {
      type: 'residents',
    };
    const data = {
      first_name: _first_name || 'test',
      last_name: _last_name || 'test',
      mac_left: _mac_left || 'test',
      mac_right: _mac_right || 'test',
      mac_down: _mac_down || 'test',
      lyingside_check: _lyingside_check || 'test',
      weight: _weight || null,
      auto_frequency_day: _auto_frequency_day || null,
      auto_frequency_night: _auto_frequency_night || null,
      user_id: _user_id || null,
      leave_hospital: _leave_hospital || null,
      case_num: _case_num || null,
      created_at: new Date().Format('yyyy-MM-ddThh:mm:ss.SZ'),
      updated_at: new Date().Format('yyyy-MM-ddThh:mm:ss.SZ'),
      // updated_at: "2021-09-02T06:42:34.941Z"
    };

    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST', //請求方法
      data: data,
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖POST - Residents〗---------
  static postCreate_Residents(_data) {
    // http://192.168.0.50:8080/create_resident
    const apiParas = {
      type: 'create_resident',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST', //請求方法
      data: _data,
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖PUT - Residents Assign to User〗---------
  static putCreate_Residents_Assign(_data) {
    // http://192.168.0.50:8080/create_resident_assign
    const apiParas = {
      type: 'create_resident_assign',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'PUT', //請求方法
      data: _data,
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖PUT - Residents Assign to User〗---------
  static deleteDelete_Residents_Assign(_data) {
    // http://192.168.0.50:8080/delete_resident_assign
    const apiParas = {
      type: 'delete_resident_assign',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'DELETE', //請求方法
      data: _data,
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖POST - back_to_hospital_Residents〗---------
  static postBackToHospital(_data, id) {
    // http://192.168.0.50:8080/back_to_hospital
    const apiParas = {
      type: 'back_to_hospital',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${id}`,
      method: 'POST', //請求方法
      data: _data,
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖PUT - 修改受護者〗---------
  static update_user(_data) {
    // 'http://192.168.0.50:8080/update_user?email=AAA'
    const apiParas = {
      type: 'update_user',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?email=${_data.email}`,
      method: 'PUT', //請求方法
      data: _data,
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖PUT - 修改受護者密碼〗---------
  static update_user_password(_data) {
    // 'http://192.168.0.98:8080/update_user_password?email=zxc'
    const apiParas = {
      type: 'update_user_password',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?email=${_data.email}`,
      method: 'PUT', //請求方法
      data: _data,
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖DELETE - 刪除受護者〗---------
  static deleteUser(_email, _role) {
    // http://192.168.0.50:8080/delete_user?email=_email&role=_role
    const apiParas = {
      type: 'delete_user',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?email=${_email}&role=${_role}`,
      method: 'DELETE', //請求方法
      type: apiParas.type,
    });
  }

  // Ω ===============【宣佑 scientech - API】===============
  /**
   * 宣佑API URL:
   * http://192.168.0.50:81/docs#/
   * Get API: get_latest_sensors_value
   * Get API: get_sensors_value_history_record
   * tip: 目前資料只有9/30~10/1
   */
  // NOTE: scientech Info
  /**
   * // ✎NOTE: ---------〖GET - 取得 scientech Info / 取得最新sensors_value〗---------
   *
   * @param {String} _mac_left 數值 1: MAC ID
   */
  static getScientech_SensorsValue(_mac_left) {
    // http://192.168.0.50:81/get_latest_sensors_value?mac=B827EB80B170
    const apiParas = {
      type: 'get_latest_sensors_value',
      // mac_left: _mac_left || 'B827EB80B170',

      // 參數寫在這裡面 // mac=B827EB80B170
      searchParams: new URLSearchParams({
        mac: _mac_left || 'B827EB80B170',
        // type: 'Code'
      }),
    };

    let Url = new URL(`${comm_data.API_HOST}:${comm_data.API_SCIENTECH_PORT}/${apiParas.type}`);
    Url.search = apiParas.searchParams; // ?mac=B827EB80B170
    return api({
      // url: Url
      url: Url.href,
    });
  }

  /**
     * // ✎NOTE: ---------〖GET - 取得 scientech Info / 取得 sensors_value 歷史記錄〗---------
     *
     * @param {String} _mac_left 數值 1: MAC ID

    *     - door: (0:關, 1:開)
     *     - vb_toilet: (1:震動)
     *     - humid: (濕度)
     *     - temp: (溫度)
     * @param {String} _from_date 數值 3: 查詢開始日期(YYYY-MM-DD)
     * @param {String} _to_date 數值 4: 查詢結束日期(YYYY-MM-DD)
     */
  // static getScientech_SensorsValueHistory(_mac_left, _sensor_type, _from_date, _to_date) {
  static getScientech_SensorsValueHistory(_mac_left, _sensor_type, _from_date, _to_date) {
    // http://192.168.0.50:81/get_sensors_value_history_record?from_date=2021-09-30&to_date=2021-10-01&mac=B827EB80B170&sensor_type=temp
    const apiParas = {
      type: 'get_sensors_value_history_record',

      // 參數寫在這裡面 // mac=B827EB80B170
      searchParams: new URLSearchParams({
        mac: _mac_left || 'B827EB80B170',
        sensor_type: _sensor_type || 'door',
        from_date: _from_date || '2021-09-30', // 2021-09-30~2021-10-01 一定有資料的故設為預設值
        to_date: _to_date || '2021-10-01',
      }),
    };

    let Url = new URL(`${comm_data.API_HOST}:${comm_data.API_SCIENTECH_PORT}/${apiParas.type}`);
    Url.search = apiParas.searchParams; // ?mac=B827EB80B170

    return api({
      // url: Url
      url: Url.href,
    });
  }

  /**
   * // ✎NOTE: ---------〖GET - 取得 scientech Info / 取得 sensors_value 歷史記錄〗---------
   *
   * @param {String} _mac_left 數值 1: MAC ID
   * @param {String} _sensor_type 數值 2: sensor 類型
   *     - door: (0:關, 1:開)
   *     - vb_toilet: (1:震動)
   *     - humid: (濕度)
   *     - temp: (溫度)
   * @param {String} _from_date 數值 3: 查詢開始日期(YYYY-MM-DD)
   * @param {String} _to_date 數值 4: 查詢結束日期(YYYY-MM-DD)
   */

  // ✎NOTE: ---------〖POST - Login〗---------
  static login(email, encrypted_password, type, os) {
    // http://192.168.0.50/login
    const apiParas = {
      type: 'login',
    };
    const data = {
      email: email,
      encrypted_password: encrypted_password,
      type: type,
      os: os,
    };

    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST', //請求方法
      data: data,
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖POST - Logout〗---------
  static logout(email, type, os) {
    // http://192.168.0.50/logout
    const apiParas = {
      type: 'logout',
    };
    const data = {
      email: email,
      type: type,
      os: os,
    };

    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST', //請求方法
      data: data,
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖POST - Logout〗---------
  static check_close_browser(_flag) {
    // http://192.168.0.98:8080/receive_close_browser
    const apiParas = {
      type: 'receive_close_browser',
    };
    const data = {
      close_browser: _flag,
      audit_trail_record: {
        // institution: _institution || "TEST Inst",
        institution: String(ApiGo_AuditTrail.getUser() !== null ? ApiGo_AuditTrail.getUser().institution : 'TEST Inst'),
        user_id: Number(ApiGo_AuditTrail.getUser() !== null ? ApiGo_AuditTrail.getUser().id : 'logout'),
        action: String(`使用者關閉網頁，${_flag ? '確認' : '取消關閉'}`),
        i18n_type: String('CHECK_CLOSE_BROWSER'),
      },
    };

    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST', //請求方法
      data: data,
      type: apiParas.type,
      audit_trial_excluded: true,
    });
  }
  // ✎NOTE: ---------〖GET - Logout〗---------
  static check_close_browser_refresh(_flag) {
    // http://192.168.0.98:8080/check_close_browser
    const apiParas = {
      type: 'check_close_browser',
    };

    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
      audit_trial_excluded: true,
    });
  }
  // ✎NOTE: ---------〖POST - verify_user〗---------
  static verifyUser(email, flag, type, os) {
    // http://192.168.0.50/verify_user
    const apiParas = {
      type: 'verify_user',
    };
    const data = {
      email: email,
      verify_flag: flag,
      encrypted_password: 123456,
      type: type,
      os: os,
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST', //請求方法
      data: data,
      type: apiParas.type,
      audit_trial_excluded: true,
    });
  }

  // ✎NOTE: ---------〖PUT - update_user_activation〗---------
  static updateActivationUser(email, _flag) {
    // 'http://demo.mwgcare.com:8080/update_user_activation?email=z'
    const apiParas = {
      type: 'update_user_activation',
    };
    const data = {
      activation: _flag,
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?email=${email}`,
      method: 'PUT', //請求方法
      data: data,
      type: apiParas.type,
      msg: `account:${email}, ${_flag ? 'blocked ' : 'unblocked'}`,
    });
  }

  // ✎NOTE: ---------〖POST - create_user〗---------
  static postCreate_User(_data) {
    // http://192.168.0.50/create_user
    const apiParas = {
      type: 'create_user',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST', //請求方法
      data: _data,
      type: apiParas.type,
    });
  }
  // NOTE: Bed auto parameters setting
  /**
   * // ✎NOTE: ---------〖GET - 查目前讓bed的最新資訊_含自動翻身次數〗---------
   *
   * @param {Integer} _period 數值 1: 輸入白天_day、晚上_night
   * @param {Integer} _bed_id 數值 2: 輸入該床的bed_id
   */
  static getBedAuto_parameter_setting(period, _bed_id) {
    const apiParas = {
      type: 'bed_auto_parameter_setting',
      period: period || 'day',
      bed_id: _bed_id || null,
    };

    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}_${period}_form/${apiParas.bed_id}`,
    });
  }

  // NOTE: Get users
  /**
   * // ✎NOTE: ---------〖GET - 查目前照護者資訊〗---------
   *
   * @param {Integer} _period 數值 1: 輸入白天_day、晚上_night
   * @param {Integer} _bed_id 數值 2: 輸入該床的bed_id
   */
  static getUsers() {
    const apiParas = {
      type: 'get_users',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
    });
  }

  // NOTE: Get all mac alert setting
  /**
   * // ✎NOTE: ---------〖GET - 查目前照護者資訊〗---------
   *
   * @param {Integer} _period 數值 1: 輸入白天_day、晚上_night
   * @param {Integer} _bed_id 數值 2: 輸入該床的bed_id
   */
  // 更新 getAll_mac_alert_setting 方法
  static async getAll_mac_alert_setting() {
    const apiParas = {
      type: 'get_all_mac_alert_setting',
    };

    try {
      const response = await api({
        url: `${comm_data.API_HOST}/${apiParas.type}`,
      });

      // 確保回傳有 data 屬性，若無則回傳空陣列
      if (response && response.data) {
        return response.data;
      } else {
        console.warn('Response does not contain data:', response);
        return [];
      }
    } catch (error) {
      console.error('Failed to fetch mac alert settings:', error);
      throw error;
    }
  }


  // NOTE: Delete Pad
  /**
   * // ✎NOTE: ---------〖DELETE - 解除 Pad〗---------
   *
   * @param {String} mac 數值 1: MAC ID
   */
  static deleteSmart_pad(mac) {
    // url:'http://localhost/remove_smart_pad?mac='+mac,
    const apiParas = {
      type: 'remove_smart_pad',

      // 參數寫在這裡面 // mac=B827EB80B170
      searchParams: new URLSearchParams({
        mac: mac || null,
        // type: 'Code'
      }),
    };

    let Url = new URL(`${comm_data.API_HOST}/${apiParas.type}`);
    Url.search = apiParas.searchParams; // ?mac=B827EB80B170

    return api({
      url: Url.href,
      method: 'DELETE', //請求方法 //需要與否需驗證
      type: apiParas.type,
    });
  }

  static remove_tr(mac) {
    // url:'http://192.168.0.50:8080/remove_tr?mac=aaa,
    const apiParas = {
      type: 'remove_tr',
      mac: mac,
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?mac=${mac}`,
      method: 'DELETE', //請求方法 //需要與否需驗證
      type: apiParas.type,
    });
  }

  /**
   * // ✎NOTE: ---------〖Post - 分配 Pad〗---------
   *
   * @param {String} mac 數值 1: MAC ID
   */
  static postMatching_smart_pad(_selectedPad, bed_id = '', from_id = '', to_id) {
    // url:`http://${HOST}/matching_smart_pad`,
    const apiParas = {
      type: 'matching_smart_pad',
    };
    const data = {
      mac: _selectedPad,
      from_bed_id: bed_id,
      from_resident_id: from_id,
      to_resident_id: to_id,
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST', //請求方法 //需要與否需驗證
      data: data,
      type: apiParas.type,
    });
  }

  // NOTE: leave_hospital
  /**
   * // ✎NOTE: ---------〖DELETE - 出院〗---------
   *
   * @param {String} mac 數值 1: MAC ID
   */
  static deleteHospital(id) {
    // url:'http://localhost/remove_smart_pad?mac='+mac,
    const apiParas = {
      type: 'leave_hospital',

      // 參數寫在這裡面 // mac=B827EB80B170
      searchParams: new URLSearchParams({
        id: id || null,
      }),
    };

    let Url = new URL(`${comm_data.API_HOST}/${apiParas.type}`);
    Url.search = apiParas.searchParams; // ?mac=B827EB80B170

    return api({
      url: Url.href,
      method: 'DELETE', //請求方法 //需要與否需驗證
      type: apiParas.type,
    });
  }

  // NOTE: leave_hospital
  /**
   * // ✎NOTE: ---------〖DELETE - 出院〗---------
   *
   * @param {String} mac 數值 1: MAC ID
   */
  static deleteResident_info(id) {
    // url:'http://localhost/remove_resident_info?mac='+mac,
    const apiParas = {
      type: 'remove_resident_info',

      // 參數寫在這裡面 // mac=B827EB80B170
      searchParams: new URLSearchParams({
        id: id || null,
      }),
    };

    let Url = new URL(`${comm_data.API_HOST}/${apiParas.type}`);
    Url.search = apiParas.searchParams; // ?mac=B827EB80B170

    return api({
      url: Url.href,
      method: 'DELETE', //請求方法 //需要與否需驗證
      type: apiParas.type,
    });
  }

  // NOTE: Get mac alert setting
  /**
   * // ✎NOTE: ---------〖GET - 查目前mac alert 設定資訊〗---------
   * // // http://192.168.0.50/get_mac_alert_setting?mac=246F2854E190
   * @param {string} mac 數值 1: 輸入mac
   */

  // NOTE: Get all mac alert setting
  /**
  * // ✎NOTE: ---------〖GET - 查目前mac alert 設定資訊〗---------
  * // // http://192.168.0.50/get_all_mac_alert_setting
  */
  static getALLMac_alert_setting() {
    const apiParas = {
      type: 'get_all_mac_alert_setting',
    };

    let Url = new URL(`${comm_data.API_HOST}/${apiParas.type}`);
    // 原先這裡寫了 Url.search，但似乎不需要 searchParams 所以刪除
    // 確保 URL 正確生成

    return api({
      url: Url.href,
      method: 'GET', // 請求方法
    }).then((response) => {
      if (response.status === "success" && Array.isArray(response.data)) {
        // 返回數據數組，保證前端調用時能直接使用
        return response.data;
      } else {
        throw new Error("Invalid response format or failed status");
      }
    });
  }

  // // NOTE: Update_volumn_Mac_Alert_Setting
  // // /*
  // // ✎NOTE: ---------〖PUT - 修改感測照護設定〗---------
  // //  *
  // //  * @param {String} _JSON 數值 1: 整組需要傳送的key:value
  // //  * @param {String} _id 數值 2: 受護者 ID
  // //  *
  // //  */
  static putUpdate_Mac_Volumn_Alert_Setting(_JSON) {
    const apiParas = {
      type: 'update_mac_volumn_alert_setting',
    };
    let Url = new URL(`${comm_data.API_HOST}/${apiParas.type}`);

    return api({
      url: Url.href,
      // url:`${comm_data.API_HOST}/${apiParas.type}`,
      method: 'PUT', // 請求方法
      data: _JSON,
      type: apiParas.type,
    });
  }
  // NOTE: Get mac alert setting
  /**
   * // ✎NOTE: ---------〖GET - 查目前mac alert 設定資訊〗---------
   * // // http://192.168.0.50/get_mac_alert_setting?mac=246F2854E190
   * @param {string} mac 數值 1: 輸入mac
   */
  static getMac_alert_setting(mac) {
    const apiParas = {
      type: 'get_mac_alert_setting',

      // 參數寫在這裡面 // mac=B827EB80B170
      searchParams: new URLSearchParams({
        mac: mac || null,
      }),
    };

    let Url = new URL(`${comm_data.API_HOST}/${apiParas.type}`);
    Url.search = apiParas.searchParams; // ?mac=B827EB80B170

    return api({
      url: Url.href,
      method: 'GET', // 請求方法 //需要與否需驗證
    }).then((response) => {
      if (response.status === "success") {
        // 確保 API 格式正確並返回 data
        return response.data;
      } else {
        throw new Error("Invalid response format or failed status");
      }
    });
  }
  // NOTE: Residents_Personal_Info
  // /*
  // ✎NOTE: ---------〖PUT - 修改個人資料〗---------
  //  *
  //  * @param {String} _JSON 數值 1: 整組需要傳送的key:value
  //  *    first_name ,
  //  *    last_name ,
  //  *    med_record_num ,
  //  *    special_conditions ,
  //  *    height ,
  //  *    weight ,
  //  *    gender ,
  //  *    birthday ,
  //  *    blood_type ,
  //  *    address ,
  //  *    emergency_contact ,
  //  *    home_phone ,
  //  *    cell_phone ,
  //  *    created_at: (new Date()).Format("yyyy-MM-ddThh:mm:ss.SZ"),
  //  *    updated_at: (new Date()).Format("yyyy-MM-ddThh:mm:ss.SZ")
  //  * @param {String} _id 數值 2: 受護者 ID
  //  *
  //  */
  static putResidents_personal_info(_JSON, _id) {
    const apiParas = {
      type: 'residents_personal_info',

      searchParams: new URLSearchParams({
        id: _id || null,
      }),
    };

    let Url = new URL(`${comm_data.API_HOST}/${apiParas.type}`);
    Url.search = apiParas.searchParams; // ?mac=B827EB80B170

    return api({
      url: Url.href,
      method: 'PUT', // 請求方法
      data: _JSON,
      type: apiParas.type,
      msg: `I'm changed the height value: ${_JSON.height}`,
      // msg: i18n.t('GLOBAL.STATUS.SUCCESS')+": "+_JSON.height //
    });
  }

  // NOTE: Update_Mac_Alert_Setting
  // /*
  // ✎NOTE: ---------〖PUT - 修改感測照護設定〗---------
  //  *
  //  * @param {String} _JSON 數值 1: 整組需要傳送的key:value
  //  *    first_name,
  //  *    last_name,
  //  *    alert_level_day,
  //  *    alert_level_mid,
  //  *    alert_level_night,
  //  *    leaving_overtime_from_time,
  //  *    leaving_overtime_to_time,
  //  *    leaving_overtime_day,
  //  *    long_stay_day,
  //  *    breath_high,
  //  *    breath_low,
  //  *    created_at: (new Date()).Format("yyyy-MM-ddThh:mm:ss.SZ"),
  //  *    updated_at: (new Date()).Format("yyyy-MM-ddThh:mm:ss.SZ")
  //  * @param {String} _id 數值 2: 受護者 ID
  //  *
  //  */
  static putUpdate_Mac_Alert_Setting(_JSON, _mac) {
    const apiParas = {
      type: 'update_mac_alert_setting',

      searchParams: new URLSearchParams({
        mac: _mac || null,
      }),
    };
    let Url = new URL(`${comm_data.API_HOST}/${apiParas.type}`);
    Url.search = apiParas.searchParams; // ?mac=B827EB80B170

    return api({
      url: Url.href,
      // url:`${comm_data.API_HOST}/${apiParas.type}`,
      method: 'PUT', // 請求方法
      data: _JSON,
      type: apiParas.type,
    });
  }

  // NOTE: Update_Start_At_Time
  // /*
  // ✎NOTE: ---------〖PUT - 修改三班開始時間〗---------
  //  *
  //  * @param {String} _period 數值 1: 日班、夜班、大夜班
  //  * @param {String} _time 數值 2: 開始時間
  //  * @param {String} _mac 數值 3: 指定床墊mac
  //  * EX: http://192.168.0.50:8080/update_start_at_time?period=night&start_time=23%3A00%3A00
  //  * EX: http://192.168.0.50:8080/update_start_at_time?period=night&start_time=23%3A59%3A59&mac=B8F009B54258
  //  */

  static putUpdate_Start_At_Time(_period, _time, _mac) {
    const apiParas = {
      type: 'update_start_at_time',
      period: _period,
      time: _time,
      mac: _mac || '',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?period=${apiParas.period}&start_time=${apiParas.time}&mac=${apiParas.mac}`,
      method: 'PUT', //請求方法
      type: apiParas.type,
    });
  }
  // NOTE: Update_Start_At_Time_Admin
  // /*
  // ✎NOTE: ---------〖PUT - 一次性修改三班開始時間〗---------
  //  *
  //  * @param {String} _day 數值 1: 日班
  //  * @param {String} _mid 數值 2: 夜班
  //  * @param {String} _night 數值 3: 大夜班
  //  * EX: http://192.168.0.50:8080/update_start_at_time_admin?day_time=08%3A00%3A05&mid_time=16%3A00%3A10&night_time=23%3A00%3A15
  //  */

  static putUpdate_Start_At_Time_Admin(_day, _mid, _night) {
    const apiParas = {
      type: 'update_start_at_time_admin',
      day: _day,
      mid: _mid,
      night: _night,
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?day_time=${apiParas.day}&mid_time=${apiParas.mid}&night_time=${apiParas.night}`,
      method: 'PUT', //請求方法
      data: null,
      type: apiParas.type,
    });
  }
  // NOTE: Update_Start_At_Time_Superdoctor
  // /*
  // ✎NOTE: ---------〖PUT - 個別修改三班開始時間〗---------
  //  *
  //  * @param {String} _period 數值 1: 日班、夜班、大夜班
  //  * @param {String} _time 數值 2: 開始時間
  //  * @param {String} _mac 數值 3: 指定床墊mac
  //  * EX: http://192.168.0.50:8080/update_start_at_time_superdoctor?period=night&start_time=23%3A00%3A10&mac=B8F009B54258
  //  */

  static putUpdate_Start_At_Time_Superdoctor(_period, _time, _mac) {
    const apiParas = {
      type: 'update_start_at_time_superdoctor',
      period: _period,
      time: _time,
      mac: _mac,
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?period=${apiParas.period}&start_time=${apiParas.time}&mac=${apiParas.mac}`,
      method: 'PUT', //請求方法
      data: null,
      type: apiParas.type,
    });
  }
  static postSend_set_auto_param_command(_period, _JSON) {
    // http://192.168.0.50/send_set_day_auto_param_command
    // http://192.168.0.50/send_set_night_auto_param_command
    const apiParas = {
      type: `send_set_${_period}_auto_param_command`,
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST', //請求方法
      data: _JSON,
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖GET - institution_img〗---------
  // 首頁圖片 + icon
  static getInstitution_img() {
    // http://192.168.0.50/institution_img
    const apiParas = {
      type: 'institution_img',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖POST - institution_img〗---------
  // 首頁圖片 + icon
  static postInstitution_img(institution_name, LogoImg, HeroImg, LogoImg_width, LogoImg_height, HeroImg_width, HeroImg_height) {
    // http://192.168.0.50/institution_img
    const apiParas = {
      type: 'institution_img',
    };
    const data = {
      institution_name: institution_name,
      LogoImg: LogoImg,
      HeroImg: HeroImg,
      LogoImg_width: LogoImg_width,
      LogoImg_height: LogoImg_height,
      HeroImg_width: HeroImg_width,
      HeroImg_height: HeroImg_height,
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST', //請求方法
      data: data,
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖POST - institution_img〗---------
  // 首頁圖片 + icon
  static postTxtimport(_data) {
    // http://192.168.0.50:8080/txtimport
    const apiParas = {
      type: 'txtimport',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST', //請求方法
      data: _data,
      type: apiParas.type,
    });
  }

  static getDevice_connection_latest_status() {
    // 'http://192.168.0.30:8080/device_connection_latest_status' \
    const apiParas = {
      type: 'device_connection_latest_status',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖get - 取得 device_connection_record_login 〗---------
  // 首頁圖片 + icon
  static getDevice_connection_record_login() {
    // http://192.168.0.50:8080/device_connection_record_login
    const apiParas = {
      type: 'device_connection_record_login',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖get - 取得 device_connection_record_login 〗---------
  // 首頁圖片 + icon
  static getDevice_connection_record_logout() {
    // http://192.168.0.50:8080/device_connection_record_logout
    const apiParas = {
      type: 'device_connection_record_logout',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖get - 取得audit trial 〗---------
  // 首頁圖片 + icon
  static getAudit_trail_get_single(id) {
    // http://192.168.0.50/audit_trail_get_single
    const apiParas = {
      type: 'audit_trail_get_single',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?id=${id}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  static getAudit_trail_get_all() {
    // http://192.168.0.50/audit_trail_get_all
    const apiParas = {
      type: 'audit_trail_get_all',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖POST - wifi_connect〗---------
  static postWifi_connect(_data) {
    // http://192.168.0.50:8080/wifi_connect
    const apiParas = {
      type: 'wifi_connect',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST', //請求方法
      data: _data,
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖get - 取得目前連線wifi 〗---------
  // 首頁圖片 + icon
  static getCurrent_wifi_setting() {
    // http://192.168.0.50:8080/current_wifi_setting
    const apiParas = {
      type: 'current_wifi_setting',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖get - 取得系統重啟時間 〗---------
  // 首頁圖片 + icon
  static getLast_system_restart_time() {
    // http://192.168.0.50:8080/last_system_restart_time
    const apiParas = {
      type: 'last_system_restart_time',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖get - 取得場域內所有wifi 〗---------
  // 首頁圖片 + icon
  static get_wifi_info() {
    // http://192.168.0.50:8080/get_wifi_info
    const apiParas = {
      type: 'get_wifi_info',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖get - 取得TCPIP setting 〗---------
  // 首頁圖片 + icon
  static get_current_tcp_ip_info() {
    // http://192.168.0.50:8080/current_tcp_ip_info
    const apiParas = {
      type: 'current_tcp_ip_info',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖post - 手動更改 TCPIP setting 〗---------
  // 首頁圖片 + icon
  static post_manual_setting(_data) {
    // http://192.168.0.50:8080/advanced_network_settings
    const apiParas = {
      type: 'advanced_network_settings',
      data: _data,
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST', //請求方法
      data: apiParas.data,
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖get - 取得資料庫備份清單 〗---------
  // 首頁圖片 + icon
  static getlist_db_archive() {
    // http://192.168.0.50:8080/list_db_archive
    const apiParas = {
      type: 'list_db_archive',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖get - 取得資料庫備份清單 〗---------
  // 首頁圖片 + icon
  static getlist_log_archive() {
    // http://192.168.0.50:8080/list_log_archive
    const apiParas = {
      type: 'list_log_archive',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖get - 手動備份功能 〗---------
  // 首頁圖片 + icon
  static getDb_archive() {
    // http://192.168.0.50:8080/db_archive
    const apiParas = {
      type: 'db_archive',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖get - 下載指定DB備份檔 〗---------
  // 首頁圖片 + icon
  static getDownload_db_archive(_DB) {
    // http://192.168.0.50:8080/download_db_archive
    const apiParas = {
      type: 'download_db_archive',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?filename=${_DB}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖get - 下載指定log備份檔 〗---------
  // 首頁圖片 + icon
  static getDownload_log_archive(_Log) {
    // http://192.168.0.50:8080/download_log_archive
    const apiParas = {
      type: 'download_log_archive',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?filename=${_Log}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖delete - 刪除指定DB備份檔 〗---------
  // 首頁圖片 + icon
  static delete_db_archive(_db) {
    // http://192.168.0.50:8080/delete_db_archive
    const apiParas = {
      type: 'delete_db_archive',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?filename=${_db}`,
      method: 'DELETE', //請求方法
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖delete - 刪除指定log備份檔 〗---------
  // 首頁圖片 + icon
  static delete_log_archive(_Log) {
    // http://192.168.0.50:8080/delete_log_archive
    const apiParas = {
      type: 'delete_log_archive',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?filename=${_Log}`,
      method: 'DELETE', //請求方法
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖get - 重啟系統 〗---------
  // 首頁圖片 + icon
  static get_system_restart() {
    // http://192.168.0.50:8080/system_restart
    const apiParas = {
      type: 'system_restart',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖get - 關閉系統 〗---------
  // 首頁圖片 + icon
  static get_system_shutdown() {
    // http://192.168.0.50:8080/system_shutdown
    const apiParas = {
      type: 'system_shutdown',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖PUT - repeat_alert_filter 修改〗---------
  // 更新全域重複警訊過濾
  // http://192.168.0.50:8080/update_repeat_alert_filter?mins=1
  static put_update_repeat_alert_filter(mins) {
    // http://192.168.0.50:8080/line_notify_group_title
    const apiParas = {
      type: 'update_repeat_alert_filter',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?mins=${mins}`,
      method: 'PUT',
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖PUT - repeat_alert_filter 修改〗---------
  // 更新全域躁動過濾
  // http://192.168.0.50:8080/update_sit_up_filter?mins=5
  static put_update_sit_up_filter(mins) {
    // http://192.168.0.50:8080/line_notify_group_title
    const apiParas = {
      type: 'update_sit_up_filter',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?mins=${mins}`,
      method: 'PUT',
      type: apiParas.type,
    });
  }

  // NOTE: Send_Commands
  // /*
  // ✎NOTE: ---------〖POST - 〗---------
  //  *
  //  * @param {String} _type 數值 1: 翻身按鈕種類
  //  * @param {String} _id 數值 2: 受護者 ID
  //  * @param {String} _mode 數值 3: 捉取外部元素
  //  *
  //  * http://192.168.0.50:8080/send_auto_command/20/1
  //  * http://192.168.0.50:8080/send_all_lock_command/20/1
  //  * http://192.168.0.50:8080/send_lie_flat_and_lowest_command/20
  //  * http://192.168.0.50:8080/send_lie_flat_command/20
  //  * http://192.168.0.50:8080/send_lowest_command/20
  //  */
  static postSend_type_command(_type, _id, _mode) {
    const apiParas = {
      type: `send_${_type}_command`,
      id: _id || '',
      mode: _mode || '',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${apiParas.id}/${apiParas.mode}`,
      method: 'POST', //請求方法
      data: null,
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖PUT - Residents Assign to User〗---------
  static putUpdate_bug_level(_level) {
    // http://192.168.0.50:8080/update_bug_level?level=debug
    const apiParas = {
      type: 'update_bug_level',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?level=${_level}`,
      method: 'PUT', //請求方法
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖PUT - Residents Assign to User〗---------
  static get_bug_level(_level) {
    // http://192.168.0.50:8080/get_bug_level
    const apiParas = {
      type: 'get_bug_level',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖PUT - Residents Assign to User〗---------
  static putUpdate_k(_min, _weight, _mac) {
    // http://192.168.0.50:8080/update_k
    const apiParas = {
      type: 'update_k',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?mins=${_min}&weight=${_weight}&mac=${_mac}`,
      method: 'PUT', //請求方法
      type: apiParas.type,
    });
  }
  static update_institution(mac, new_institution) {
    // http://192.168.0.30:8080/update_institution
    const apiParas = {
      type: 'update_institution',
    };
    let _data = {
      mac: mac,
      new_institution: new_institution,
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'PUT',
      data: _data,
      type: apiParas.type,
    });
  }

  static update_bed_name(mac, new_bed_name) {
    const apiParas = {
      type: 'update_bed_name',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'PUT',
      data: { mac, new_bed_name },
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖GET - institution check〗---------
  // 更新全域重複警訊過濾
  // http://192.168.0.50:8080/update_repeat_alert_filter?mins=1
  static institutioncheck(mins) {
    // http://192.168.0.50:8080/institutioncheck
    const apiParas = {
      type: 'institutioncheck',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET',
      type: apiParas.type,
    });
  }

  static update_bed_number(mac, new_bed_number) {
    // http://192.168.1.124:8080/update_bed_number
    const apiParas = {
      type: 'update_bed_number',
    };
    let _data = {
      mac: mac,
      new_bed_number: String(new_bed_number),
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'PUT',
      data: _data,
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖DELETE - delete institution〗---------
  static deletInstitution(institution) {
    // http://192.168.0.50:8080/delete_institution?institution=a
    const apiParas = {
      type: 'delete_institution',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?institution=${institution}`,
      method: 'DELETE',
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖POST - create institution〗---------
  static create_institution(institution) {
    // http://192.168.0.50:8080/create_institution
    const apiParas = {
      type: 'create_institution',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST',
      data: { institution: institution },
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖GET - Get Unit〗---------
  static get_unit(int = 0) {
    // http://192.168.0.50:8080/get_unit?institution_id=0
    const apiParas = {
      type: 'get_unit',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?institution_id=${int}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖DELETE - delete Unit〗---------
  static create_unit(_data) {
    // http://192.168.0.50:8080/create_unit
    const apiParas = {
      type: 'create_unit',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST', //請求方法
      data: _data,
      type: apiParas.type,
    });
  }
  // ✎NOTE: ---------〖DELETE - delete Unit〗---------
  static delete_unit(int = 0) {
    // http://192.168.0.50:8080/delete_unit?id=0
    const apiParas = {
      type: 'delete_unit',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}?id=${int}`,
      method: 'DELETE', //請求方法
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖get - check auto para, 〗---------
  // 判斷自動翻身床參數一致性
  static getCheck_curr_auto_param(_residentID) {
    // http://192.168.0.50:8080/check_curr_auto_param/20
    const apiParas = {
      type: 'check_curr_auto_param',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${_residentID}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }

  // ✎NOTE: ---------〖get - check auto para, 〗---------
  // 判斷自動翻身床參數一致性
  static getSet_auto_param_by_system(_period, _residentID) {
    // http://192.168.0.50:8080/set_auto_param_by_system/_period/_residentID
    const apiParas = {
      type: 'set_auto_param_by_system',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${_period}/${_residentID}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  /**
   * 讀取 慶生/記者會資料
   */
  static get_diaper_datas(_residentID) {
    // http://192.168.0.50:8080/check_curr_auto_param/20
    const apiParas = {
      type: 'get_diaper_datas',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${Number(_residentID)}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }

  static get_diaper_history_abnormal(Date, timestamp) {
    // http://192.168.0.50:8080/all_resident_diaper_abnormal/2022-07-28/ALL
    const apiParas = {
      type: 'all_resident_diaper_abnormal',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${Date}/${timestamp}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }

  static get_diaper_datas_history(_residentID, from_time, to_time) {
    // http://192.168.0.99:8080/get_diaper_datas_history/1/2022-06-13%2000%3A00%3A00/2022-06-13%2023%3A59%3A59
    const apiParas = {
      type: 'get_diaper_datas_history',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${Number(_residentID)}/${from_time}/${to_time}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  /**
   * 讀取 慶生/記者會資料
   */
  static set_moteck_simulator_start() {
    // http://192.168.0.50:8080/check_curr_auto_param/20
    const apiParas = {
      type: 'moteck_simulator_start',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  static set_moteck_simulator_stop() {
    // http://192.168.0.50:8080/check_curr_auto_param/20
    const apiParas = {
      type: 'moteck_simulator_stop',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  static set_diaper_simulator_start() {
    // http://192.168.0.50:8080/check_curr_auto_param/20
    const apiParas = {
      type: 'diaper_simulator_start',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }
  static set_diaper_simulator_stop() {
    // http://192.168.0.50:8080/check_curr_auto_param/20
    const apiParas = {
      type: 'diaper_simulator_stop',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }

  static set_uart_test_restart() {
    // 'http://192.168.0.50:8080/uart_test_restart'
    const apiParas = {
      type: 'uart_test_restart',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }

  static start_update_service(email, encrypted_password, type, os) {
    // http://192.168.0.50/start_update_service
    const apiParas = {
      type: 'start_update_service',
    };
    const data = {
      email: email,
      encrypted_password: encrypted_password,
      type: type,
      os: os,
    };

    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}`,
      method: 'POST', //請求方法
      data: data,
      type: apiParas.type,
    });
  }
  static getPatientData_chartNo(InhospType = 'IPD', PatNo) {
    // http://192.168.0.50/getPatientData_chartNo?InhospType=a&PatNo=a
    const apiParas = {
      type: 'kmtth_soap/getPatientData_chartNo',
    };
    return api({
      // url: `${apiParas.host}/${apiParas.type}?InhospType=${InhospType}&PatNo=${PatNo}`,
      url: `${comm_data.API_HOST}/${apiParas.type}?InhospType=${InhospType}&PatNo=${PatNo}`,
      method: 'GET', //請求方法
      type: apiParas.type,
    });
  }

  // 傳送每日報表給 highchart export server
  static postDaily_Report(_resident_id, _option) {
    // http://192.168.0.50:8080/HR_RR_abnormal_info/
    const apiParas = {
      type: 'Daily_Report',
    };
    return api({
      url: `${comm_data.API_HOST}/${apiParas.type}/${_resident_id}`,
      data: _option,
      method: 'POST',
      type: apiParas.type,
      audit_trial_excluded: true,
    });
  }
}
